<!--说明-->
<!--1.如果传入标准答案answer的话，组件只是用来展示，不会响应用户的选择而改变绑定的value值-->
<!--2.optionFlag表示多选还是单选-->
<template>
  <div class="TopicOptions">
    <div v-if="optionContent.length != 0">
      <ul style="margin: 0;padding: 0">
        <li
          class="options"
          @click.prevent="selectOption(option.optionType)"
          :class="{
            active: value.indexOf(option.optionType) !== -1,
            answer: answer.indexOf(option.optionType + '') !== -1
          }"
          :key="i"
          v-for="(option, i) in optionContent"
        >
          <div class="option-name">
            {{ option.optionTypeDesc }}
          </div>
          <div class="option-content" v-html="option.optionTextHtml"></div>
          <div class="answer">
            <div class="green-mark">
              正确
            </div>
          </div>
        </li>
      </ul>
      <template v-if="canSeeAnswer && T.index">
        <div class="content" v-if="T.type == 1 || T.type == 2">
          <div class="correct-answer">
            正确答案：{{ T.answer.map(r => LetterArr[r]).join("") }}
          </div>
          <div class="rich-text">
            <span class="tip">试题解析：</span>
            <div
              style="display: inline-block"
              v-html="T.answerContentHtml || T.answerContent"
            ></div>
          </div>
        </div>
        <div class="content" v-else>
          <div class="correct-answer">
            正确答案：{{ q.answer.map(r => LetterArr[r]).join("") }}
          </div>
          <div class="rich-text">
            <span class="tip">试题解析：</span>
            <div
              style="display: inline-block"
              v-if="q.answerContentHtml || q.answerContent"
              v-html="q.answerContentHtml || q.answerContent"
            ></div>
          </div>
        </div>
      </template>
    </div>
    <div class="empty" v-else>暂无选项</div>
  </div>
</template>

<script>
import { LetterArr } from "@/components/topic/utils/topic";

export default {
  name: "TopicOptions",
  props: {
    optionContent: {
      //选项
      type: Array,
      default: function() {
        return [];
      }
    },
    q: {
      type: Object,
      default: function() {
        return {};
      }
    },
    canSeeAnswer: {
      type: Boolean,
      default: true
    },
    T: {
      type: Object,
      default: function() {
        return {};
      }
    },
    value: Array, //用户答案
    answer: {
      //标准答案
      type: Array,
      default: function() {
        return [];
      }
    },
    optionFlag: {
      type: Number,
      default: 1 //1单选,其他为多选择
    }
  },
  data: function() {
    return {
      LetterArr: LetterArr
    };
  },
  computed: {
    currentIndex: function() {
      if (!this.T.hasOwnProperty("index")) return "0";
      let index = this.T.index;
      if (index.length === 1) {
        return index[0];
      }
      return index[0] + "~" + index[index.length - 1];
    }
  },
  methods: {
    selectOption(optionType) {
      if (this.answer.length != 0) {
        //有标准答案展示点击没反应
        return;
      }
      if (1 == this.optionFlag) {
        this.$emit("input", [optionType]);
      } else {
        //多选择
        let userAnswer = [];
        let hasClickVal = false; //当前点击的选择在之前的答案里面
        this.value.forEach(val => {
          if (optionType != val) {
            userAnswer.push(val);
          } else {
            hasClickVal = true;
          }
        });
        if (!hasClickVal) {
          userAnswer.push(optionType);
        }
        this.$emit("input", userAnswer.sort());
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/style/var.scss";

.TopicOptions {
  .empty {
    text-align: center;
    padding: 50px;
  }

  .content {
    margin-left: 3%;

    .correct-answer {
      margin: 8px 0;
      color: $--color-primary;
      font-size: 23px;
    }

    .tip {
      color: #333;
      font-weight: bold;
      font-size: 19px;
    }
  }

  .options {
    width: 100%;
    min-height: 38px;
    display: flex;
    cursor: pointer;
    margin: 8px 0;
    padding: 6px 0;
    align-items: center;
    /*transition: background-color ease-in 0.3s;*/
    &.active {
      background-color: #fff6ea;
    }

    &.answer {
      background-color: #f3f5f7;
    }

    .option-name {
      width: 22px;
      height: 22px;
      display: flex;
      border-radius: 50%;
      border: 1px solid #999999;
      justify-content: center;
      align-items: center;
      color: #999999;
      margin-right: 16px;
      margin-left: 23px;
      /*transition: all ease-in 0.3s;*/
    }

    &.active {
      .option-name {
        border-color: #f2a536;
        background-color: #f2a536;
        color: #fff;
      }
    }

    .option-content {
      flex: 1;
      display: flex;
      align-items: center;
      overflow-x: auto;
      font-size: 16px;
      color: #666;

      video {
        width: 100%;
      }

      img {
        width: 100%;
      }

      audio {
        width: 100%;
      }

      p {
        margin: 4px;
        font-size: 16px;
        word-break: break-all;
      }
    }

    .answer {
      width: 62px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .green-mark {
        display: none;
        width: 38px;
        color: #fff;
        text-align: center;
        line-height: 16px;
        height: 16px;
        font-size: 12px;
        background: rgba(49, 179, 89, 1);
        border: 1px solid rgba(46, 164, 82, 1);
        border-radius: 2px;
      }
    }

    &.answer {
      .answer {
        .green-mark {
          display: block;
        }
      }
    }
  }
}
</style>
